import { ofSeq, empty, tail as tail_6, head, isEmpty, reverse, cons } from "../fable-library.3.7.20/List.js";
import { compare, equals } from "../fable-library.3.7.20/Util.js";
import { singleton, map, append, empty as empty_1, delay } from "../fable-library.3.7.20/Seq.js";
import { Union } from "../fable-library.3.7.20/Types.js";
import { union_type, list_type } from "../fable-library.3.7.20/Reflection.js";

export function List_partitionWhile(p, input) {
    const loop = (acc_mut, _arg_mut) => {
        loop:
        while (true) {
            const acc = acc_mut, _arg = _arg_mut;
            let pattern_matching_result, hd_1, tl_1, rest;
            if (!isEmpty(_arg)) {
                if (p(head(_arg))) {
                    pattern_matching_result = 0;
                    hd_1 = head(_arg);
                    tl_1 = tail_6(_arg);
                }
                else {
                    pattern_matching_result = 1;
                    rest = _arg;
                }
            }
            else {
                pattern_matching_result = 1;
                rest = _arg;
            }
            switch (pattern_matching_result) {
                case 0: {
                    acc_mut = cons(hd_1, acc);
                    _arg_mut = tl_1;
                    continue loop;
                }
                case 1: {
                    return [reverse(acc), rest];
                }
            }
            break;
        }
    };
    return loop(empty(), input);
}

export function List_partitionWhileLookahead(p, input) {
    const loop = (acc_mut, _arg_mut) => {
        loop:
        while (true) {
            const acc = acc_mut, _arg = _arg_mut;
            let pattern_matching_result, hd_1, tl_1, rest;
            if (!isEmpty(_arg)) {
                if (p(cons(head(_arg), tail_6(_arg)))) {
                    pattern_matching_result = 0;
                    hd_1 = head(_arg);
                    tl_1 = tail_6(_arg);
                }
                else {
                    pattern_matching_result = 1;
                    rest = _arg;
                }
            }
            else {
                pattern_matching_result = 1;
                rest = _arg;
            }
            switch (pattern_matching_result) {
                case 0: {
                    acc_mut = cons(hd_1, acc);
                    _arg_mut = tl_1;
                    continue loop;
                }
                case 1: {
                    return [reverse(acc), rest];
                }
            }
            break;
        }
    };
    return loop(empty(), input);
}

export function List_partitionUntil(p, input) {
    return List_partitionWhile((arg) => (!p(arg)), input);
}

export function List_partitionUntilLookahead(p, input) {
    return List_partitionWhileLookahead((arg) => (!p(arg)), input);
}

export function List_iterInterleaved(f_mut, g_mut, input_mut) {
    List_iterInterleaved:
    while (true) {
        const f = f_mut, g = g_mut, input = input_mut;
        if (isEmpty(input)) {
        }
        else if (isEmpty(tail_6(input))) {
            f(head(input));
        }
        else {
            f(head(input));
            g();
            f_mut = f;
            g_mut = g;
            input_mut = cons(head(tail_6(input)), tail_6(tail_6(input)));
            continue List_iterInterleaved;
        }
        break;
    }
}

export function List_partitionUntilEquals(endl, input) {
    const loop = (acc_mut, _arg_mut) => {
        let loop_1;
        loop:
        while (true) {
            const acc = acc_mut, _arg = _arg_mut;
            if ((loop_1 = ((start_1_mut, list_1_mut) => {
                loop_1:
                while (true) {
                    const start_1 = start_1_mut, list_1 = list_1_mut;
                    const matchValue = [start_1, list_1];
                    let pattern_matching_result, x_1, xs_1, y_1, ys_1;
                    if (isEmpty(matchValue[0])) {
                        pattern_matching_result = 1;
                    }
                    else if (!isEmpty(matchValue[1])) {
                        if (equals(head(matchValue[0]), head(matchValue[1]))) {
                            pattern_matching_result = 0;
                            x_1 = head(matchValue[0]);
                            xs_1 = tail_6(matchValue[0]);
                            y_1 = head(matchValue[1]);
                            ys_1 = tail_6(matchValue[1]);
                        }
                        else {
                            pattern_matching_result = 2;
                        }
                    }
                    else {
                        pattern_matching_result = 2;
                    }
                    switch (pattern_matching_result) {
                        case 0: {
                            start_1_mut = xs_1;
                            list_1_mut = ys_1;
                            continue loop_1;
                        }
                        case 1: {
                            return true;
                        }
                        case 2: {
                            return false;
                        }
                    }
                    break;
                }
            }), loop_1(endl, _arg))) {
                return [reverse(acc), _arg];
            }
            else if (isEmpty(_arg)) {
                return void 0;
            }
            else {
                acc_mut = cons(head(_arg), acc);
                _arg_mut = tail_6(_arg);
                continue loop;
            }
            break;
        }
    };
    return loop(empty(), input);
}

export function List_nestUnderLastMatching(f, input) {
    const loop = (input_1) => delay(() => {
        const patternInput = List_partitionUntil(f, input_1);
        const other = patternInput[1];
        const matchValue = reverse(patternInput[0]);
        if (isEmpty(matchValue)) {
            if (equals(other, empty())) {
                return empty_1();
            }
            else {
                throw (new Error("Should start with true\\nParameter name: "));
                return empty_1();
            }
        }
        else {
            return append(map((p) => [p, empty()], reverse(tail_6(matchValue))), delay(() => {
                const patternInput_1 = List_partitionUntil((arg) => (!f(arg)), other);
                return append(singleton([head(matchValue), patternInput_1[0]]), delay(() => loop(patternInput_1[1])));
            }));
        }
    });
    return ofSeq(loop(input));
}

export class Tree$1 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Node"];
    }
}

export function Tree$1$reflection(gen0) {
    return union_type("Fable.Formatting.Collections.Tree`1", [gen0], Tree$1, () => [[["Item1", gen0], ["Item2", list_type(Tree$1$reflection(gen0))]]]);
}

function Tree_takeAtLevel(indent, tail) {
    let pattern_matching_result, i_1, tail_2, value_1, tail_5;
    if (!isEmpty(tail)) {
        if (compare(head(tail)[0], indent) >= 0) {
            pattern_matching_result = 0;
            i_1 = head(tail)[0];
            tail_2 = tail_6(tail);
            value_1 = head(tail)[1];
        }
        else {
            pattern_matching_result = 1;
            tail_5 = tail;
        }
    }
    else {
        pattern_matching_result = 1;
        tail_5 = tail;
    }
    switch (pattern_matching_result) {
        case 0: {
            const patternInput = Tree_takeDeeperThan(i_1, tail_2);
            const patternInput_1 = Tree_takeAtLevel(indent, patternInput[1]);
            return [cons(new Tree$1(0, value_1, patternInput[0]), patternInput_1[0]), patternInput_1[1]];
        }
        case 1: {
            return [empty(), tail_5];
        }
    }
}

function Tree_takeDeeperThan(indent, tail) {
    let pattern_matching_result, i_1, tail_2, value_1, tail_5;
    if (!isEmpty(tail)) {
        if (compare(head(tail)[0], indent) > 0) {
            pattern_matching_result = 0;
            i_1 = head(tail)[0];
            tail_2 = tail_6(tail);
            value_1 = head(tail)[1];
        }
        else {
            pattern_matching_result = 1;
            tail_5 = tail;
        }
    }
    else {
        pattern_matching_result = 1;
        tail_5 = tail;
    }
    switch (pattern_matching_result) {
        case 0: {
            const patternInput = Tree_takeDeeperThan(i_1, tail_2);
            const patternInput_1 = Tree_takeAtLevel(i_1, patternInput[1]);
            return [cons(new Tree$1(0, value_1, patternInput[0]), patternInput_1[0]), patternInput_1[1]];
        }
        case 1: {
            return [empty(), tail_5];
        }
    }
}

export function Tree_ofIndentedList(input) {
    const patternInput = Tree_takeAtLevel(0, input);
    if (!equals(patternInput[1], empty())) {
        throw (new Error("Wrong indentation"));
    }
    return patternInput[0];
}

